var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Public-Group-List",
    transform: "translate(-1078.000000, -455.000000)",
    fill: "#14376f",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(130.000000, 390.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(948.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-4",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8611049,0 L10.8333151,0 C10.2440779,0 9.67889817,0.234068663 9.26208187,0.650846599 C8.84526557,1.06762453 8.61123732,1.63284569 8.61123732,2.22228325 L8.61123732,3.30601897 C8.49149006,3.3007873 8.3711674,3.29691228 8.25006597,3.29691228 L2.22227623,3.29691228 C1.63284054,3.29691228 1.06766085,3.53098094 0.650844545,3.94775888 C0.234062964,4.36454177 0,4.92975797 0,5.51919553 L0,22.7777168 C0,23.3671543 0.234067925,23.9323358 0.650844545,24.3491534 C1.06762117,24.765971 1.63284054,25 2.22227623,25 L14.1667444,25 C14.7559817,25 15.3211614,24.7659313 15.7379777,24.3491534 C16.154794,23.9323755 16.3888222,23.3671543 16.3888222,22.7777168 L16.3888222,21.7031081 L22.7777238,21.7031081 C23.3671595,21.7031081 23.9323392,21.4690394 24.3491555,21.0522615 C24.765937,20.6354786 25,20.0702624 25,19.4808248 L25,8.13900065 C25,5.9802594 24.1426074,3.91010988 22.6161163,2.38401076 C21.0898236,0.857713237 19.0196806,0 16.8611446,0 L16.8611049,0 Z M14.7222118,22.7778948 C14.7222118,23.0848161 14.473372,23.3334036 14.1666551,23.3334036 L2.22218695,23.3334036 C1.9152667,23.3334036 1.66667989,23.0848061 1.66667989,22.7778948 L1.66667989,5.5193736 C1.66667989,5.21245238 1.91527662,4.96386479 2.22218695,4.96386479 L8.47219935,4.96386479 C11.7396165,4.96386479 10.4348025,8.3022252 11.279447,9.20515643 C11.8607477,9.82673701 14.7222118,8.35455682 14.7222118,11.6173216 L14.7222118,22.7778948 Z M23.3333399,8.32047927 L23.3333399,19.4812509 C23.3333399,19.7881721 23.0846936,20.0367597 22.7777833,20.0367597 L16.3888817,20.0367597 L16.3888817,11.4360211 C16.3888817,9.63015862 15.7884341,7.87563571 14.6820331,6.44839623 C13.5758305,5.02115676 12.0265219,4.0021535 10.2778081,3.55165516 L10.2778081,2.22223364 C10.2778081,1.91531242 10.5265983,1.66672483 10.8333151,1.66672483 L17.0833275,1.66672483 C20.3507447,1.66672483 19.0459306,5.00508524 19.8905752,5.90801647 C20.4718759,6.52959705 23.3333399,5.05741686 23.3333399,8.32018165 L23.3333399,8.32047927 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.83956130ba3e7683ccba4862323938f5.svg";
export { ForwardRef as ReactComponent };